export default __webpack_public_path__ + "static/media/animation021-03.da4d9467.svg";